import { parseQueryStrings } from '@crehana/utils';
import trackUserActivity from "./trackUserActivity";
import { UserActivityEvent } from "./types";
export function trackSearchClick() {
  var queryParams = parseQueryStrings(window.location.search);
  if (queryParams && queryParams.source === 'search') {
    try {
      var eventData = {
        position_selected: parseInt(queryParams.position_selected, 10),
        model_used: queryParams.model_used,
        product_name: decodeURIComponent(queryParams.product_name),
        product_id: parseInt(queryParams.product_id, 10),
        keyword: decodeURIComponent(queryParams.keyword),
        item_type: 'course'
      };
      trackUserActivity({
        event: UserActivityEvent.SEARCH_CLICK,
        data: eventData
      });
    } catch (err) {
      console.error('> Error to send the track search_click', err);
    }
  }
}